import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'referenceFonciereRange',
  standalone: true,
})
export class ReferenceFonciereRangePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    const references = value.split(',').map((ref) => ref.trim());
    if (references.length === 1) return references[0];
    if (references.length === 2) return `${references[0]} - ${references[1]}`;
    if (references.length === 0) return value;

    const sortedReferences = references.sort();
    return `${sortedReferences[0]} ... ${sortedReferences[sortedReferences.length - 1]}`;
  }
}
